/**
 * Registry for SortableManager instances to coordinate multi-drag operations across components
 */
import { SortableManagerApi } from './useSortableManager';
const registry = new Set<SortableManagerApi>();

/**
 * Registers a SortableManager instance in the global registry
 * @param manager - The SortableManager instance to register
 */
export const registerManager = (manager: SortableManagerApi) => {
  registry.add(manager);
};

/**
 * Unregisters a SortableManager instance from the global registry
 * @param manager - The SortableManager instance to unregister
 */
export const unregisterManager = (manager: SortableManagerApi) => {
  registry.delete(manager);
};

/**
 * Deselects all items across all registered SortableManager instances
 */
export const deselectAllManagers = () => {
  registry.forEach((manager: SortableManagerApi) => manager.deselectAll());
};
